import React, { useEffect, useState } from 'react'
import useFetchEntitiesWithCache from '../../hooks/useFetchEntitiesWithCache'
import { useAtom } from 'jotai'
import { useFilterIssues } from '../issues/utils'
import { issueFiltersAtom, IssueFilterType } from '../../atoms/issueAtom'
import { ScatterPlot } from './ScatterPlot'
import { useLogUserEvent } from '../../hooks/useLogUserEvent'
import UserEventApi from '../../api/UserEventApi'

export const ScatterPlotView = () => {
    useLogUserEvent(UserEventApi.EVENT_TYPES.SHOW_STATS_SCATTER_PLOT)
    const { isLoading, result: fetchedIssues } = useFetchEntitiesWithCache('issue')
    const [filters, setFilters] = useAtom(issueFiltersAtom)
    const filteredIssues = useFilterIssues(fetchedIssues || [], filters)
    const [oldFilter, setOldFilter] = useState<IssueFilterType | null>(null)

    useEffect(() => {
        setFilters((prevFilters) => {
            if (!oldFilter) setOldFilter(prevFilters)

            return {
                ...prevFilters,
                issueTypes: {
                    value: ['Rights issue'],
                    disabledItems: ['Directed issue', 'IPO', 'Non-cash issue'],
                },
            }
        })

        return () => {
            if (oldFilter) setFilters((filters) => ({ ...filters, issueTypes: { ...oldFilter.issueTypes } }))
        }
    }, [setFilters, setOldFilter, oldFilter])

    return <ScatterPlot isLoading={isLoading} issues={filteredIssues} />
}
